// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .heading__one {
    color: red;
    background-color: skyblue;
}


.filter-nav {
  display: flex;
}

.filter-nav-item {
  padding: 10px 30px 10px 10px;
  border: 1px solid #000;
  position: relative;
}

.filter-nav-counter {
  position: absolute;;
  top: 0;
  right: 0;
  background: #000;
  color: #fff;
  font-size: 12px;
  padding: 4px;
  display: none;

}
.filter-nav-counter.visible {
  display: block;
}
.filter-nav-counter.icon span {
  display: none;

}
.filter-nav-counter.icon:after {
  content: "<->";

}

.filter-nav-item.open {
  background: red;
}


.filter-section {
  display: none;
  padding: 10px;
  border: 1px solid black;

}

.filter-section.open {
  display: block;
} */
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAqDG","sourcesContent":["/* .heading__one {\r\n    color: red;\r\n    background-color: skyblue;\r\n}\r\n\r\n\r\n.filter-nav {\r\n  display: flex;\r\n}\r\n\r\n.filter-nav-item {\r\n  padding: 10px 30px 10px 10px;\r\n  border: 1px solid #000;\r\n  position: relative;\r\n}\r\n\r\n.filter-nav-counter {\r\n  position: absolute;;\r\n  top: 0;\r\n  right: 0;\r\n  background: #000;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  padding: 4px;\r\n  display: none;\r\n\r\n}\r\n.filter-nav-counter.visible {\r\n  display: block;\r\n}\r\n.filter-nav-counter.icon span {\r\n  display: none;\r\n\r\n}\r\n.filter-nav-counter.icon:after {\r\n  content: \"<->\";\r\n\r\n}\r\n\r\n.filter-nav-item.open {\r\n  background: red;\r\n}\r\n\r\n\r\n.filter-section {\r\n  display: none;\r\n  padding: 10px;\r\n  border: 1px solid black;\r\n\r\n}\r\n\r\n.filter-section.open {\r\n  display: block;\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
